import React from "react";
import { useSelector } from "react-redux";
import ExportModal from "../../../../components/Modal/ExportModal/ExportModal";
import MuiDataTable from "../../../../components/Table/MuiDataTable/MuiDataTable";
import { USER_REQUESTS } from "../../../../constants/constants";
import { getAllowedActionsList } from "../../../../helpers/tableUtils";
import RejectedUserRequestsStyles from "./RejectedUserRequests.styles";
import useUserRequestsTable, { getSearchQuery } from "../useUserRequestsTable";

export { getSearchQuery };

// ***** This component is to show the list of rejected user requests*****//

const RejectedUserRequests = () => {
  const rejectedTimekeeperAccessibility = useSelector(
    (state) => state?.accessibility?.applicationAccess?.organization?.tabs?.people?.tabs?.rejected
  );
  const classes = RejectedUserRequestsStyles();

  const {
    userColumns,
    setUserColumns,
    userRequestData,
    loading,
    userAccessCustomOptions,
    exportLoading,
    createExportLoading,
    modalOpen,
    selectRowsData,
    rowsData,
    currentPageExport,
    setCurrentPageExport,
    exportSelection,
    setExportSelection,
    showExportAllOption,
    onCancelBtnClk,
    handleExportBtnClk,
    handleRowSelectionChange,
    handleRowClick,
    resetSelectedRows,
    onClickCreate,
  } = useUserRequestsTable({
    statusFilter: 'rejected',
    requestPath: 'rejected-request/',
    selectedPeopleTab: 2,
  });

  return (
    <div className={classes.rowStyle} data-testid="user-access">
      <MuiDataTable
        data={userRequestData?.userRequests}
        columns={userColumns}
        loading={loading}
        selectableRowsType={"multiple"}
        customOptions={userAccessCustomOptions}
        setTableColumns={setUserColumns}
        exportLoading={exportLoading}
        onExportClick={handleExportBtnClk}
        selectedRows={selectRowsData}
        onRowSelection={handleRowSelectionChange}
        onRowClick={handleRowClick}
        hideAddNewButton={true}
        allowedActions={getAllowedActionsList(rejectedTimekeeperAccessibility)}
        resetSelectedRows={() => resetSelectedRows()}
      />
      <ExportModal
        title={USER_REQUESTS}
        mode={modalOpen}
        onCancel={onCancelBtnClk}
        onCreate={onClickCreate}
        rowsData={rowsData}
        exportSelection={exportSelection}
        setExportSelection={setExportSelection}
        currentPageExport={currentPageExport}
        showExportAllOption={showExportAllOption}
        setCurrentPageExport={setCurrentPageExport}
        exportLoading={createExportLoading}
      />
    </div>
  );
};

export default RejectedUserRequests;
